<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <supplier-form v-if="supplier"
          @submit="submit"
          :init-supplier="supplier"
          :val-errors="valErrors"
          submit-text="Speichern"
        />
      </card>
    </div>
  </div>
</template>

<script>
import SupplierForm from './supplier-form'

export default {
  components: { SupplierForm },
  data () {
    return {
      supplier: null,
      valErrors: []
    }
  },
  methods: {
    async submit (supplier) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.put(`/suppliers/${supplier.id}`, supplier).then(({ data }) => {
        this.$notify({
          message: 'Lieferant erfolgreich bearbeitet.',
          type: 'success'
        })
        this.redirectBack('/suppliers')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    }
  },
  created () {
    this.$http.get(`/suppliers/${this.$route.params.id}`).then(({ data }) => {
      this.supplier = data
    })
  }
}
</script>

<style>
</style>
